import { IFSkeleton } from 'Components'
import React from 'react'
import Styles from './ConnectorStatusChart.module.css'

const ConnectorStatusChartSkeleton = ({}) => {
  return (
    <div className={Styles.WrapperContainer}>
      <div className={Styles.MapHeaderSkeleton}>
        <IFSkeleton width="150px" height="20px" />
        <IFSkeleton height={20} width={30} />
      </div>
      <div className={Styles.GraphContainerSkeleton}>
        <IFSkeleton width="62%" height={55} />
        <div className={Styles.LegendSkeleton}>
          <div className={Styles.LegendItemSkeleton}>
            <IFSkeleton width="12px" height="20px" />
            <IFSkeleton width="80px" height="20px" />
          </div>
          <div className={Styles.LegendItemSkeleton}>
            <IFSkeleton width="12px" height="20px" />
            <IFSkeleton width="80px" height="20px" />
          </div>
          <div className={Styles.LegendItemSkeleton}>
            <IFSkeleton width="12px" height="20px" />
            <IFSkeleton width="80px" height="20px" />
          </div>
          <div className={Styles.LegendItemSkeleton}>
            <IFSkeleton width="12px" height="20px" />
            <IFSkeleton width="80px" height="20px" />
          </div>
          <div className={Styles.LegendItemSkeleton}>
            <IFSkeleton width="12px" height="20px" />
            <IFSkeleton width="80px" height="20px" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConnectorStatusChartSkeleton
